// extracted by mini-css-extract-plugin
export default {"vennQueryPill":"VennQueryPill_vennQueryPill__XZdCJ","op":"VennQueryPill_op__-j0Ka","value":"VennQueryPill_value__KOFnJ"};